/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AIScreeningTranscriptVendorError,
  AIScreeningValidationError,
  ApplicantInviteResponse,
  ApplicantInvitesRequest,
  ApplicantTeaser,
  CandidateTimeline,
  ConvertibleShiftsResponse,
  DirectHireCreateRequest,
  DirectHirePreviewResponse,
  FunnelCounts,
  HireJobsActivityListParams,
  HireJobsApplicantsFunnelCountsRetrieveParams,
  HireJobsApplicantsInvitesCreateParams,
  HireJobsApplicantsListParams,
  HireJobsWorkedWithYouRetrieveParams,
  HireLocationsConvertibleShiftsRetrieveParams,
  HireLocationsDirectHirePreviewRetrieveParams,
  HireLocationsOfferableJobsRetrieveParams,
  HireLocationsWeeklyPatternRetrieveParams,
  JobApplicantAIScreening,
  JobApplicantAIScreeningEnvelope,
  JobApplicantAIScreeningTranscriptEnvelope,
  JobApplicantDetailResponse,
  JobApplicantResponse,
  JobCandidateInvite,
  JobCandidatesFunnelCountsRetrieveParams,
  JobCandidatesListParams,
  JobCandidatesTeaserRetrieveParams,
  OfferableJobsResponse,
  PaginatedJobActivityEventList,
  PaginatedJobApplicantResponseList,
  PatchedJobApplicantRequest,
  ReadyToHireResponse,
  StafferJobOffer,
  TryoutOfferRequest,
  TryoutShiftsResponse,
  WeeklyPatternResponse,
  WorkedWithYouProsResponse,
  WorkingInterviewConversion,
  WorkingInterviewConversionRequestRequest,
  WorkingInterviewCreateRequest,
  WorkingInterviewCreateResponse,
  WorkingInterviewPanel,
  WorkingInterviewResult,
  WorkingInterviewSeriesCreated,
  WorkingInterviewSeriesPreview,
  WorkingInterviewSeriesPreviewRequestRequest,
  WorkingInterviewSeriesRequestRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHireJobsActivityListUrl = (jobPostingId: string,
    params?: HireJobsActivityListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${jobPostingId}/activity/?${stringifiedParams}` : `/api/hire/jobs/${jobPostingId}/activity/`
}

/**
 * What the system did on this job, newest first: invites and why, bookings, declines, cancellations, reopened seats and last-call splits. 404 when the job is not at a location the caller manages.
 */
export const hireJobsActivityList = async (jobPostingId: string,
    params?: HireJobsActivityListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobActivityEventList> => {

  return customFetch<PaginatedJobActivityEventList>(getHireJobsActivityListUrl(jobPostingId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsActivityListInfiniteQueryKey = (jobPostingId: string,
    params?: HireJobsActivityListParams,) => {
    return [
    'infinite', `/api/hire/jobs/${jobPostingId}/activity/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireJobsActivityListQueryKey = (jobPostingId: string,
    params?: HireJobsActivityListParams,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/activity/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsActivityListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireJobsActivityList>>, HireJobsActivityListParams['page']>, TError = void>(jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData, QueryKey, HireJobsActivityListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsActivityListInfiniteQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsActivityList>>, QueryKey, HireJobsActivityListParams['page']> = ({ signal, pageParam }) => hireJobsActivityList(jobPostingId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData, QueryKey, HireJobsActivityListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsActivityListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsActivityList>>>
export type HireJobsActivityListInfiniteQueryError = void


export function useHireJobsActivityListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsActivityList>>, HireJobsActivityListParams['page']>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsActivityListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData, QueryKey, HireJobsActivityListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsActivityList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsActivityList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsActivityListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsActivityList>>, HireJobsActivityListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData, QueryKey, HireJobsActivityListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsActivityList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsActivityList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsActivityListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsActivityList>>, HireJobsActivityListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData, QueryKey, HireJobsActivityListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsActivityListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsActivityList>>, HireJobsActivityListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData, QueryKey, HireJobsActivityListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsActivityListInfiniteQueryOptions(jobPostingId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsActivityListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsActivityList>>, TError = void>(jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsActivityListQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsActivityList>>> = ({ signal }) => hireJobsActivityList(jobPostingId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsActivityListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsActivityList>>>
export type HireJobsActivityListQueryError = void


export function useHireJobsActivityList<TData = Awaited<ReturnType<typeof hireJobsActivityList>>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsActivityListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsActivityList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsActivityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsActivityList<TData = Awaited<ReturnType<typeof hireJobsActivityList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsActivityList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsActivityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsActivityList<TData = Awaited<ReturnType<typeof hireJobsActivityList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsActivityList<TData = Awaited<ReturnType<typeof hireJobsActivityList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsActivityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsActivityList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsActivityListQueryOptions(jobPostingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsListUrl = (jobPostingId: string,
    params?: HireJobsApplicantsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${jobPostingId}/applicants/?${stringifiedParams}` : `/api/hire/jobs/${jobPostingId}/applicants/`
}

/**
 * Job applicants API (access control via queryset).
 *
 * Mounted twice: nested under a job as ``/hire/jobs/{job_id}/applicants/`` (canonical) and at the
 * deprecated flat ``/job-candidates/`` where the job is a query param instead. On the nested route
 * the ``job_posting_id`` path segment scopes the list; the query param is ignored there.
 *
 * - GET /hire/jobs/{job_id}/applicants/ - list applicants for a job
 * - GET /job-candidates/?job_posting_id={uuid} - deprecated flat equivalent
 * - GET .../{id}/ - get applicant detail
 * - GET .../{id}/timeline/ - get applicant's interviews and job offers
 * - GET .../{id}/ai-screening/transcript/ - fetch AI screening transcript on demand
 * - PATCH .../{id}/ - update applicant (e.g., {"stage": "REJECTED"})
 * - POST .../{id}/invite/resend/ - resend an SMS invite to apply (once)
 *
 * Supports ordering:
 * - ordering: Sort by -match_score (default), -created_ts, -avg_rating, or -completion_percentage
 *
 * Boolean filters (is_preferred and in_network need a job — the path segment on the nested route,
 * the job_posting_id query param on the flat one):
 * - is_preferred: Filter by favorited pros at the location
 * - in_network: Filter by pros in the organization's network
 * - background_check: Filter by pros with cleared background checks
 * - food_handler: Filter by pros with active Food Handler certification
 * - alcohol_safety: Filter by pros with active Alcohol Safety certification
 * - qwick_certified: Filter by Qwick-certified pros
 * - has_badges: Filter by pros with active tiered badges (GOLD/SILVER/BRONZE)
 * - employment_types: Filter by pro's supported employment type(s) (W2/F1099, comma-separated)
 * - worked_with_you: true keeps applicants who count as "worked with you"; false leaves them out
 *
 * All boolean filters use AND logic when combined.
 */
export const hireJobsApplicantsList = async (jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobApplicantResponseList> => {

  return customFetch<PaginatedJobApplicantResponseList>(getHireJobsApplicantsListUrl(jobPostingId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsListInfiniteQueryKey = (jobPostingId: string,
    params?: HireJobsApplicantsListParams,) => {
    return [
    'infinite', `/api/hire/jobs/${jobPostingId}/applicants/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireJobsApplicantsListQueryKey = (jobPostingId: string,
    params?: HireJobsApplicantsListParams,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsApplicantsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireJobsApplicantsList>>, HireJobsApplicantsListParams['page']>, TError = void>(jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData, QueryKey, HireJobsApplicantsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsListInfiniteQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsList>>, QueryKey, HireJobsApplicantsListParams['page']> = ({ signal, pageParam }) => hireJobsApplicantsList(jobPostingId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData, QueryKey, HireJobsApplicantsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsList>>>
export type HireJobsApplicantsListInfiniteQueryError = void


export function useHireJobsApplicantsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsApplicantsList>>, HireJobsApplicantsListParams['page']>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsApplicantsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData, QueryKey, HireJobsApplicantsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsApplicantsList>>, HireJobsApplicantsListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData, QueryKey, HireJobsApplicantsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsApplicantsList>>, HireJobsApplicantsListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData, QueryKey, HireJobsApplicantsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsApplicantsList>>, HireJobsApplicantsListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData, QueryKey, HireJobsApplicantsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsListInfiniteQueryOptions(jobPostingId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError = void>(jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsListQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsList>>> = ({ signal }) => hireJobsApplicantsList(jobPostingId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsList>>>
export type HireJobsApplicantsListQueryError = void


export function useHireJobsApplicantsList<TData = Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsApplicantsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsList<TData = Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsList<TData = Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsList<TData = Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsListQueryOptions(jobPostingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsRetrieveUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/`
}

/**
 * Job applicants API (access control via queryset).
 *
 * Mounted twice: nested under a job as ``/hire/jobs/{job_id}/applicants/`` (canonical) and at the
 * deprecated flat ``/job-candidates/`` where the job is a query param instead. On the nested route
 * the ``job_posting_id`` path segment scopes the list; the query param is ignored there.
 *
 * - GET /hire/jobs/{job_id}/applicants/ - list applicants for a job
 * - GET /job-candidates/?job_posting_id={uuid} - deprecated flat equivalent
 * - GET .../{id}/ - get applicant detail
 * - GET .../{id}/timeline/ - get applicant's interviews and job offers
 * - GET .../{id}/ai-screening/transcript/ - fetch AI screening transcript on demand
 * - PATCH .../{id}/ - update applicant (e.g., {"stage": "REJECTED"})
 * - POST .../{id}/invite/resend/ - resend an SMS invite to apply (once)
 *
 * Supports ordering:
 * - ordering: Sort by -match_score (default), -created_ts, -avg_rating, or -completion_percentage
 *
 * Boolean filters (is_preferred and in_network need a job — the path segment on the nested route,
 * the job_posting_id query param on the flat one):
 * - is_preferred: Filter by favorited pros at the location
 * - in_network: Filter by pros in the organization's network
 * - background_check: Filter by pros with cleared background checks
 * - food_handler: Filter by pros with active Food Handler certification
 * - alcohol_safety: Filter by pros with active Alcohol Safety certification
 * - qwick_certified: Filter by Qwick-certified pros
 * - has_badges: Filter by pros with active tiered badges (GOLD/SILVER/BRONZE)
 * - employment_types: Filter by pro's supported employment type(s) (W2/F1099, comma-separated)
 * - worked_with_you: true keeps applicants who count as "worked with you"; false leaves them out
 *
 * All boolean filters use AND logic when combined.
 */
export const hireJobsApplicantsRetrieve = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantDetailResponse> => {

  return customFetch<JobApplicantDetailResponse>(getHireJobsApplicantsRetrieveUrl(jobPostingId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsRetrieveQueryKey = (jobPostingId: string,
    id: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/${id}/`
    ] as const;
    }


export const getHireJobsApplicantsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError = void>(jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsRetrieveQueryKey(jobPostingId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>> = ({ signal }) => hireJobsApplicantsRetrieve(jobPostingId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>>
export type HireJobsApplicantsRetrieveQueryError = void


export function useHireJobsApplicantsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsRetrieveQueryOptions(jobPostingId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsPartialUpdateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/`
}

/**
 * Update candidate stage (e.g., "REJECTED" to dismiss a candidate).
 */
export const hireJobsApplicantsPartialUpdate = async (jobPostingId: string,
    id: string,
    patchedJobApplicantRequest?: PatchedJobApplicantRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobApplicantResponse>(getHireJobsApplicantsPartialUpdateUrl(jobPostingId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobApplicantRequest)
  }
);}





export const getHireJobsApplicantsPartialUpdateMutationKey = () => ['hireJobsApplicantsPartialUpdate'] as const;

export const getHireJobsApplicantsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsPartialUpdate>>, TError,HireJobsApplicantsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsPartialUpdate>>, TError,HireJobsApplicantsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireJobsApplicantsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsApplicantsPartialUpdate>>, HireJobsApplicantsPartialUpdateMutationVariables> = (props) => {
          const {jobPostingId,id,data} = props ?? {};

          return  hireJobsApplicantsPartialUpdate(jobPostingId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsApplicantsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsPartialUpdate>>>
    export type HireJobsApplicantsPartialUpdateMutationBody = PatchedJobApplicantRequest | undefined
    export type HireJobsApplicantsPartialUpdateMutationError = void
    export type HireJobsApplicantsPartialUpdateMutationVariables = {jobPostingId: string;id: string;data?: PatchedJobApplicantRequest}

    export const useHireJobsApplicantsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsPartialUpdate>>, TError,HireJobsApplicantsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsApplicantsPartialUpdate>>,
        TError,
        HireJobsApplicantsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsApplicantsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireJobsApplicantsAiScreeningRetrieveUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/ai-screening/`
}

/**
 * Return the most recent AI screening for the candidate inside a ``{"screening": ...}`` envelope. ``screening`` is null if none has been sent yet. When the screening status is ``COMPLETED`` and the webhook has cached the structured result, ``summary`` / ``key_takeaway`` / ``notable_quote`` / ``concerns`` are populated as flat fields on the screening object (all four stay null pre-completion or when the post-completion vendor fetch failed). A pro-initiated screening only surfaces once ``COMPLETED`` — an abandoned in-app attempt has no retry and would otherwise show as a stale pending interview to the hiring team. 404 only if the candidate is not managed by the requesting user.
 */
export const hireJobsApplicantsAiScreeningRetrieve = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantAIScreeningEnvelope> => {

  return customFetch<JobApplicantAIScreeningEnvelope>(getHireJobsApplicantsAiScreeningRetrieveUrl(jobPostingId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsAiScreeningRetrieveQueryKey = (jobPostingId: string,
    id: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/${id}/ai-screening/`
    ] as const;
    }


export const getHireJobsApplicantsAiScreeningRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError = void>(jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsAiScreeningRetrieveQueryKey(jobPostingId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>> = ({ signal }) => hireJobsApplicantsAiScreeningRetrieve(jobPostingId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsAiScreeningRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>>
export type HireJobsApplicantsAiScreeningRetrieveQueryError = void


export function useHireJobsApplicantsAiScreeningRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsAiScreeningRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsAiScreeningRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsAiScreeningRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsAiScreeningRetrieveQueryOptions(jobPostingId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsAiScreeningCreateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/ai-screening/`
}

/**
 * Send an AI screening invite to the candidate. Returns 201 when a new invite is minted, or 200 with the existing screening when one is already outstanding (non-terminal) for this candidate.
 */
export const hireJobsApplicantsAiScreeningCreate = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantAIScreening> => {

  return customFetch<JobApplicantAIScreening>(getHireJobsApplicantsAiScreeningCreateUrl(jobPostingId,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireJobsApplicantsAiScreeningCreateMutationKey = () => ['hireJobsApplicantsAiScreeningCreate'] as const;

export const getHireJobsApplicantsAiScreeningCreateMutationOptions = <TError = AIScreeningValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningCreate>>, TError,HireJobsApplicantsAiScreeningCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningCreate>>, TError,HireJobsApplicantsAiScreeningCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsApplicantsAiScreeningCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningCreate>>, HireJobsApplicantsAiScreeningCreateMutationVariables> = (props) => {
          const {jobPostingId,id} = props ?? {};

          return  hireJobsApplicantsAiScreeningCreate(jobPostingId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsApplicantsAiScreeningCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningCreate>>>

    export type HireJobsApplicantsAiScreeningCreateMutationError = AIScreeningValidationError | void
    export type HireJobsApplicantsAiScreeningCreateMutationVariables = {jobPostingId: string;id: string}

    export const useHireJobsApplicantsAiScreeningCreate = <TError = AIScreeningValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningCreate>>, TError,HireJobsApplicantsAiScreeningCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningCreate>>,
        TError,
        HireJobsApplicantsAiScreeningCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsApplicantsAiScreeningCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsApplicantsAiScreeningTranscriptRetrieveUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/ai-screening/transcript/`
}

/**
 * Fetch the raw conversation transcript for the candidate's most recent AI screening. Live fetch from the vendor — no local cache — to keep transcript data off our DB while still letting the FE render the "Read the raw conversation" view on demand.
 *
 * 404 if the candidate is not managed by the requesting user, no screening exists, or the latest screening is not in ``COMPLETED`` status. 502 if the vendor is unreachable or returns an error.
 */
export const hireJobsApplicantsAiScreeningTranscriptRetrieve = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantAIScreeningTranscriptEnvelope> => {

  return customFetch<JobApplicantAIScreeningTranscriptEnvelope>(getHireJobsApplicantsAiScreeningTranscriptRetrieveUrl(jobPostingId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsAiScreeningTranscriptRetrieveQueryKey = (jobPostingId: string,
    id: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/${id}/ai-screening/transcript/`
    ] as const;
    }


export const getHireJobsApplicantsAiScreeningTranscriptRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsAiScreeningTranscriptRetrieveQueryKey(jobPostingId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>> = ({ signal }) => hireJobsApplicantsAiScreeningTranscriptRetrieve(jobPostingId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsAiScreeningTranscriptRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>>
export type HireJobsApplicantsAiScreeningTranscriptRetrieveQueryError = void | AIScreeningTranscriptVendorError


export function useHireJobsApplicantsAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 jobPostingId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsAiScreeningTranscriptRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsAiScreeningTranscriptRetrieveQueryOptions(jobPostingId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsInviteResendCreateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/invite/resend/`
}

/**
 * Text the invite to apply again and restart its 7-day expiry. Allowed once per invite; 400 once resent, after the applicant is removed or has applied, or when there is no invite.
 */
export const hireJobsApplicantsInviteResendCreate = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobCandidateInvite> => {

  return customFetch<JobCandidateInvite>(getHireJobsApplicantsInviteResendCreateUrl(jobPostingId,id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHireJobsApplicantsInviteResendCreateMutationKey = () => ['hireJobsApplicantsInviteResendCreate'] as const;

export const getHireJobsApplicantsInviteResendCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsInviteResendCreate>>, TError,HireJobsApplicantsInviteResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsInviteResendCreate>>, TError,HireJobsApplicantsInviteResendCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsApplicantsInviteResendCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsApplicantsInviteResendCreate>>, HireJobsApplicantsInviteResendCreateMutationVariables> = (props) => {
          const {jobPostingId,id} = props ?? {};

          return  hireJobsApplicantsInviteResendCreate(jobPostingId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsApplicantsInviteResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsInviteResendCreate>>>

    export type HireJobsApplicantsInviteResendCreateMutationError = void
    export type HireJobsApplicantsInviteResendCreateMutationVariables = {jobPostingId: string;id: string}

    export const useHireJobsApplicantsInviteResendCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsInviteResendCreate>>, TError,HireJobsApplicantsInviteResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsApplicantsInviteResendCreate>>,
        TError,
        HireJobsApplicantsInviteResendCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsApplicantsInviteResendCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsApplicantsTimelineRetrieveUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/timeline/`
}

/**
 * Job applicants API (access control via queryset).
 *
 * Mounted twice: nested under a job as ``/hire/jobs/{job_id}/applicants/`` (canonical) and at the
 * deprecated flat ``/job-candidates/`` where the job is a query param instead. On the nested route
 * the ``job_posting_id`` path segment scopes the list; the query param is ignored there.
 *
 * - GET /hire/jobs/{job_id}/applicants/ - list applicants for a job
 * - GET /job-candidates/?job_posting_id={uuid} - deprecated flat equivalent
 * - GET .../{id}/ - get applicant detail
 * - GET .../{id}/timeline/ - get applicant's interviews and job offers
 * - GET .../{id}/ai-screening/transcript/ - fetch AI screening transcript on demand
 * - PATCH .../{id}/ - update applicant (e.g., {"stage": "REJECTED"})
 * - POST .../{id}/invite/resend/ - resend an SMS invite to apply (once)
 *
 * Supports ordering:
 * - ordering: Sort by -match_score (default), -created_ts, -avg_rating, or -completion_percentage
 *
 * Boolean filters (is_preferred and in_network need a job — the path segment on the nested route,
 * the job_posting_id query param on the flat one):
 * - is_preferred: Filter by favorited pros at the location
 * - in_network: Filter by pros in the organization's network
 * - background_check: Filter by pros with cleared background checks
 * - food_handler: Filter by pros with active Food Handler certification
 * - alcohol_safety: Filter by pros with active Alcohol Safety certification
 * - qwick_certified: Filter by Qwick-certified pros
 * - has_badges: Filter by pros with active tiered badges (GOLD/SILVER/BRONZE)
 * - employment_types: Filter by pro's supported employment type(s) (W2/F1099, comma-separated)
 * - worked_with_you: true keeps applicants who count as "worked with you"; false leaves them out
 *
 * All boolean filters use AND logic when combined.
 */
export const hireJobsApplicantsTimelineRetrieve = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<CandidateTimeline> => {

  return customFetch<CandidateTimeline>(getHireJobsApplicantsTimelineRetrieveUrl(jobPostingId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsTimelineRetrieveQueryKey = (jobPostingId: string,
    id: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/${id}/timeline/`
    ] as const;
    }


export const getHireJobsApplicantsTimelineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError = void>(jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsTimelineRetrieveQueryKey(jobPostingId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>> = ({ signal }) => hireJobsApplicantsTimelineRetrieve(jobPostingId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsTimelineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>>
export type HireJobsApplicantsTimelineRetrieveQueryError = void


export function useHireJobsApplicantsTimelineRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsTimelineRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsTimelineRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsTimelineRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTimelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsTimelineRetrieveQueryOptions(jobPostingId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsTryoutsCreateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/tryouts/`
}

/**
 * Offer a working-interview tryout on one of the manager's shifts (see tryout-shifts): a spot on a multi-spot shift splits off into a private one-Pro shift, a one-spot shift is replaced by it. One of the job's own working-interview seats is offered to the candidate directly, with no new shift. All-or-nothing: on a 400 the original shift is untouched. 404 when the tryout feature is off for the location.
 */
export const hireJobsApplicantsTryoutsCreate = async (jobPostingId: string,
    id: string,
    tryoutOfferRequest: TryoutOfferRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewResult>(getHireJobsApplicantsTryoutsCreateUrl(jobPostingId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tryoutOfferRequest)
  }
);}





export const getHireJobsApplicantsTryoutsCreateMutationKey = () => ['hireJobsApplicantsTryoutsCreate'] as const;

export const getHireJobsApplicantsTryoutsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsTryoutsCreate>>, TError,HireJobsApplicantsTryoutsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsTryoutsCreate>>, TError,HireJobsApplicantsTryoutsCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsApplicantsTryoutsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsApplicantsTryoutsCreate>>, HireJobsApplicantsTryoutsCreateMutationVariables> = (props) => {
          const {jobPostingId,id,data} = props ?? {};

          return  hireJobsApplicantsTryoutsCreate(jobPostingId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsApplicantsTryoutsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsTryoutsCreate>>>
    export type HireJobsApplicantsTryoutsCreateMutationBody = TryoutOfferRequest
    export type HireJobsApplicantsTryoutsCreateMutationError = void
    export type HireJobsApplicantsTryoutsCreateMutationVariables = {jobPostingId: string;id: string;data: TryoutOfferRequest}

    export const useHireJobsApplicantsTryoutsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsTryoutsCreate>>, TError,HireJobsApplicantsTryoutsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsApplicantsTryoutsCreate>>,
        TError,
        HireJobsApplicantsTryoutsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsApplicantsTryoutsCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsApplicantsWorkingInterviewsCreateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/${id}/working-interviews/`
}

/**
 * Create working interview(s) for a job candidate by offering gig(s) as paid trial shifts.
 */
export const hireJobsApplicantsWorkingInterviewsCreate = async (jobPostingId: string,
    id: string,
    workingInterviewCreateRequest: WorkingInterviewCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewCreateResponse>(getHireJobsApplicantsWorkingInterviewsCreateUrl(jobPostingId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingInterviewCreateRequest)
  }
);}





export const getHireJobsApplicantsWorkingInterviewsCreateMutationKey = () => ['hireJobsApplicantsWorkingInterviewsCreate'] as const;

export const getHireJobsApplicantsWorkingInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsWorkingInterviewsCreate>>, TError,HireJobsApplicantsWorkingInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsWorkingInterviewsCreate>>, TError,HireJobsApplicantsWorkingInterviewsCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsApplicantsWorkingInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsApplicantsWorkingInterviewsCreate>>, HireJobsApplicantsWorkingInterviewsCreateMutationVariables> = (props) => {
          const {jobPostingId,id,data} = props ?? {};

          return  hireJobsApplicantsWorkingInterviewsCreate(jobPostingId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsApplicantsWorkingInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsWorkingInterviewsCreate>>>
    export type HireJobsApplicantsWorkingInterviewsCreateMutationBody = WorkingInterviewCreateRequest
    export type HireJobsApplicantsWorkingInterviewsCreateMutationError = void
    export type HireJobsApplicantsWorkingInterviewsCreateMutationVariables = {jobPostingId: string;id: string;data: WorkingInterviewCreateRequest}

    export const useHireJobsApplicantsWorkingInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsWorkingInterviewsCreate>>, TError,HireJobsApplicantsWorkingInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsApplicantsWorkingInterviewsCreate>>,
        TError,
        HireJobsApplicantsWorkingInterviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsApplicantsWorkingInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsApplicantsFunnelCountsRetrieveUrl = (jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${jobPostingId}/applicants/funnel-counts/?${stringifiedParams}` : `/api/hire/jobs/${jobPostingId}/applicants/funnel-counts/`
}

/**
 * Per-tab candidate counts for the funnel stages, honoring the same filters as the list endpoint (except funnel_stage). Lets the web app render the funnel tabs without splitting the paginated list client-side.
 */
export const hireJobsApplicantsFunnelCountsRetrieve = async (jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<FunnelCounts> => {

  return customFetch<FunnelCounts>(getHireJobsApplicantsFunnelCountsRetrieveUrl(jobPostingId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsFunnelCountsRetrieveQueryKey = (jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/funnel-counts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsApplicantsFunnelCountsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError = void>(jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsFunnelCountsRetrieveQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>> = ({ signal }) => hireJobsApplicantsFunnelCountsRetrieve(jobPostingId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsFunnelCountsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>>
export type HireJobsApplicantsFunnelCountsRetrieveQueryError = void


export function useHireJobsApplicantsFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsApplicantsFunnelCountsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsApplicantsFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsFunnelCountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsFunnelCountsRetrieveQueryOptions(jobPostingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsApplicantsInvitesCreateUrl = (jobPostingId: string,
    params?: HireJobsApplicantsInvitesCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${jobPostingId}/applicants/invites/?${stringifiedParams}` : `/api/hire/jobs/${jobPostingId}/applicants/invites/`
}

/**
 * Check or invite up to 250 people by first name, last name and phone. Each row is classified: `pro` (an eligible Qwick Pro owns the phone), `already_on_job` (already an applicant on this job), `ineligible` (a Pro outside this job's market; not invited), `new` (no Qwick Pro account) or `invalid` (see `errors`). With `?save=false` nothing is written. Otherwise `pro` rows get the regular Qwick job invite and `new` rows become an INVITED applicant texted a link to the job (a phone repeated in the request comes back `already_on_job`). Invalid rows never fail the request: the valid rows are still invited, so check with `?save=false` first.
 */
export const hireJobsApplicantsInvitesCreate = async (jobPostingId: string,
    applicantInvitesRequest: ApplicantInvitesRequest,
    params?: HireJobsApplicantsInvitesCreateParams, options?: Parameters<typeof customFetch>[1]): Promise<ApplicantInviteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ApplicantInviteResponse>(getHireJobsApplicantsInvitesCreateUrl(jobPostingId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(applicantInvitesRequest)
  }
);}





export const getHireJobsApplicantsInvitesCreateMutationKey = () => ['hireJobsApplicantsInvitesCreate'] as const;

export const getHireJobsApplicantsInvitesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsInvitesCreate>>, TError,HireJobsApplicantsInvitesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsInvitesCreate>>, TError,HireJobsApplicantsInvitesCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsApplicantsInvitesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsApplicantsInvitesCreate>>, HireJobsApplicantsInvitesCreateMutationVariables> = (props) => {
          const {jobPostingId,data,params} = props ?? {};

          return  hireJobsApplicantsInvitesCreate(jobPostingId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsApplicantsInvitesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsInvitesCreate>>>
    export type HireJobsApplicantsInvitesCreateMutationBody = ApplicantInvitesRequest
    export type HireJobsApplicantsInvitesCreateMutationError = void
    export type HireJobsApplicantsInvitesCreateMutationVariables = {jobPostingId: string;data: ApplicantInvitesRequest;params?: HireJobsApplicantsInvitesCreateParams}

    export const useHireJobsApplicantsInvitesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsApplicantsInvitesCreate>>, TError,HireJobsApplicantsInvitesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsApplicantsInvitesCreate>>,
        TError,
        HireJobsApplicantsInvitesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsApplicantsInvitesCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsApplicantsTeaserRetrieveUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/applicants/teaser/`
}

/**
 * What a location without Jobs access may see about a job's applicants, or about the whole location's when no job is given (the location comes from the location header): counts, the top 3 applied or passed-screening applicants (first name and last initial, headshot, experience, worked-with-you, AI summary, the job-candidate id and the job), and one row per other applicant with stage, applied time and distance band, never who they are. The top 3 can be opened in full through the applicant detail reads.
 */
export const hireJobsApplicantsTeaserRetrieve = async (jobPostingId: string, options?: Parameters<typeof customFetch>[1]): Promise<ApplicantTeaser> => {

  return customFetch<ApplicantTeaser>(getHireJobsApplicantsTeaserRetrieveUrl(jobPostingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsApplicantsTeaserRetrieveQueryKey = (jobPostingId: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/applicants/teaser/`
    ] as const;
    }


export const getHireJobsApplicantsTeaserRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError = void>(jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsApplicantsTeaserRetrieveQueryKey(jobPostingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>> = ({ signal }) => hireJobsApplicantsTeaserRetrieve(jobPostingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsApplicantsTeaserRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>>
export type HireJobsApplicantsTeaserRetrieveQueryError = void


export function useHireJobsApplicantsTeaserRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError = void>(
 jobPostingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsTeaserRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsApplicantsTeaserRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsApplicantsTeaserRetrieve<TData = Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsApplicantsTeaserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsApplicantsTeaserRetrieveQueryOptions(jobPostingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsCandidatesTryoutShiftsRetrieveUrl = (jobPostingId: string,
    jobCandidateId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/candidates/${jobCandidateId}/tryout-shifts/`
}

/**
 * Upcoming shifts at the job's location in the job's exact position that can host a working-interview tryout for this candidate, soonest first: at least one spot nobody is confirmed on or holding an offer for, and not an outside-system sync or another tryout. The job's own open working-interview seats (kind=working_interview) come first: nobody confirmed on one and no hand-picked offer out on it. Shifts that clash with the candidate's schedule come back with disabled=true and a reason. 404 when the job is not at a location the caller manages, the candidate did not come through this job, or the tryout feature is off for the location.
 */
export const hireJobsCandidatesTryoutShiftsRetrieve = async (jobPostingId: string,
    jobCandidateId: string, options?: Parameters<typeof customFetch>[1]): Promise<TryoutShiftsResponse> => {

  return customFetch<TryoutShiftsResponse>(getHireJobsCandidatesTryoutShiftsRetrieveUrl(jobPostingId,jobCandidateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsCandidatesTryoutShiftsRetrieveQueryKey = (jobPostingId: string,
    jobCandidateId: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/candidates/${jobCandidateId}/tryout-shifts/`
    ] as const;
    }


export const getHireJobsCandidatesTryoutShiftsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError = void>(jobPostingId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsCandidatesTryoutShiftsRetrieveQueryKey(jobPostingId,jobCandidateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>> = ({ signal }) => hireJobsCandidatesTryoutShiftsRetrieve(jobPostingId,jobCandidateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && jobCandidateId !== null && jobCandidateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsCandidatesTryoutShiftsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>>
export type HireJobsCandidatesTryoutShiftsRetrieveQueryError = void


export function useHireJobsCandidatesTryoutShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError = void>(
 jobPostingId: string,
    jobCandidateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsCandidatesTryoutShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError = void>(
 jobPostingId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsCandidatesTryoutShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError = void>(
 jobPostingId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsCandidatesTryoutShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError = void>(
 jobPostingId: string,
    jobCandidateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsCandidatesTryoutShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsCandidatesTryoutShiftsRetrieveQueryOptions(jobPostingId,jobCandidateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsConvertibleShiftsRetrieveUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/convertible-shifts/`
}

/**
 * Upcoming shifts at the job's location in the job's position with a seat nobody is confirmed on, soonest first, each with how many pros are confirmed, how many offers are outstanding, and whether it is in a recurring series or a multi-day bundle. Cancelled, unapproved, private and working-interview shifts are left out. 404 when the job is not at a location the caller manages or the working-interview feature is off for the location.
 */
export const hireJobsConvertibleShiftsRetrieve = async (jobPostingId: string, options?: Parameters<typeof customFetch>[1]): Promise<ConvertibleShiftsResponse> => {

  return customFetch<ConvertibleShiftsResponse>(getHireJobsConvertibleShiftsRetrieveUrl(jobPostingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsConvertibleShiftsRetrieveQueryKey = (jobPostingId: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/convertible-shifts/`
    ] as const;
    }


export const getHireJobsConvertibleShiftsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError = void>(jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsConvertibleShiftsRetrieveQueryKey(jobPostingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>> = ({ signal }) => hireJobsConvertibleShiftsRetrieve(jobPostingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsConvertibleShiftsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>>
export type HireJobsConvertibleShiftsRetrieveQueryError = void


export function useHireJobsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError = void>(
 jobPostingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsConvertibleShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsConvertibleShiftsRetrieveQueryOptions(jobPostingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsWorkedWithYouRetrieveUrl = (jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${jobPostingId}/worked-with-you/?${stringifiedParams}` : `/api/hire/jobs/${jobPostingId}/worked-with-you/`
}

/**
 * The Pros who "worked with you" for this job's position at its location, applied or not, best first (highest average rating, then most shifts in the position), each with their history summary and whether they already have an offer or were dismissed. When the location has no Jobs access, Pros who applied to this job are left out: their applications are hidden. 404 when the job is not at a location the caller manages.
 */
export const hireJobsWorkedWithYouRetrieve = async (jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<WorkedWithYouProsResponse> => {

  return customFetch<WorkedWithYouProsResponse>(getHireJobsWorkedWithYouRetrieveUrl(jobPostingId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsWorkedWithYouRetrieveQueryKey = (jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/worked-with-you/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsWorkedWithYouRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError = void>(jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsWorkedWithYouRetrieveQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>> = ({ signal }) => hireJobsWorkedWithYouRetrieve(jobPostingId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsWorkedWithYouRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>>
export type HireJobsWorkedWithYouRetrieveQueryError = void


export function useHireJobsWorkedWithYouRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsWorkedWithYouRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsWorkedWithYouRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsWorkedWithYouRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsWorkedWithYouRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsWorkedWithYouRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkedWithYouRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsWorkedWithYouRetrieveQueryOptions(jobPostingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsWorkingInterviewConversionsCreateUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/working-interview-conversions/`
}

/**
 * Turns one of the job's convertible shifts into a working interview. With nobody confirmed the shift converts in place and keeps its seats. With some Pros confirmed they stay on the regular shift and its open seats split off into a new working-interview shift. Either way, outstanding offers and applications for those seats are withdrawn. With seats, only that many open seats split off into a new working-interview shift, and the regular shift keeps its other seats with their applications and offers. 400 when the shift is not one of the job's convertible shifts, or seats is more than its open seats. 403 jobs_subscription_required when the location has no Jobs trial or plan. 404 when the job is not at a location the caller manages or the working-interview feature is off for the location.
 */
export const hireJobsWorkingInterviewConversionsCreate = async (jobPostingId: string,
    workingInterviewConversionRequestRequest: WorkingInterviewConversionRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewConversion> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewConversion>(getHireJobsWorkingInterviewConversionsCreateUrl(jobPostingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingInterviewConversionRequestRequest)
  }
);}





export const getHireJobsWorkingInterviewConversionsCreateMutationKey = () => ['hireJobsWorkingInterviewConversionsCreate'] as const;

export const getHireJobsWorkingInterviewConversionsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewConversionsCreate>>, TError,HireJobsWorkingInterviewConversionsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewConversionsCreate>>, TError,HireJobsWorkingInterviewConversionsCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsWorkingInterviewConversionsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsWorkingInterviewConversionsCreate>>, HireJobsWorkingInterviewConversionsCreateMutationVariables> = (props) => {
          const {jobPostingId,data} = props ?? {};

          return  hireJobsWorkingInterviewConversionsCreate(jobPostingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsWorkingInterviewConversionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsWorkingInterviewConversionsCreate>>>
    export type HireJobsWorkingInterviewConversionsCreateMutationBody = WorkingInterviewConversionRequestRequest
    export type HireJobsWorkingInterviewConversionsCreateMutationError = void
    export type HireJobsWorkingInterviewConversionsCreateMutationVariables = {jobPostingId: string;data: WorkingInterviewConversionRequestRequest}

    export const useHireJobsWorkingInterviewConversionsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewConversionsCreate>>, TError,HireJobsWorkingInterviewConversionsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsWorkingInterviewConversionsCreate>>,
        TError,
        HireJobsWorkingInterviewConversionsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsWorkingInterviewConversionsCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsWorkingInterviewSeriesCreateUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/working-interview-series/`
}

/**
 * Posts a series of working-interview shifts linked to the job, on the recurring-shift feature, up to the end date the business picks (4 weeks by default, 12 at most). The shifts are private and no Pro is offered one when it is posted. Returns the first shift; the rest follow. 403 jobs_subscription_required when the location has no Jobs trial or plan. 404 when the job is not at a location the caller manages or the working-interview feature is off for the location.
 */
export const hireJobsWorkingInterviewSeriesCreate = async (jobPostingId: string,
    workingInterviewSeriesRequestRequest: WorkingInterviewSeriesRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewSeriesCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewSeriesCreated>(getHireJobsWorkingInterviewSeriesCreateUrl(jobPostingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingInterviewSeriesRequestRequest)
  }
);}





export const getHireJobsWorkingInterviewSeriesCreateMutationKey = () => ['hireJobsWorkingInterviewSeriesCreate'] as const;

export const getHireJobsWorkingInterviewSeriesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesCreate>>, TError,HireJobsWorkingInterviewSeriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesCreate>>, TError,HireJobsWorkingInterviewSeriesCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsWorkingInterviewSeriesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesCreate>>, HireJobsWorkingInterviewSeriesCreateMutationVariables> = (props) => {
          const {jobPostingId,data} = props ?? {};

          return  hireJobsWorkingInterviewSeriesCreate(jobPostingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsWorkingInterviewSeriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesCreate>>>
    export type HireJobsWorkingInterviewSeriesCreateMutationBody = WorkingInterviewSeriesRequestRequest
    export type HireJobsWorkingInterviewSeriesCreateMutationError = void
    export type HireJobsWorkingInterviewSeriesCreateMutationVariables = {jobPostingId: string;data: WorkingInterviewSeriesRequestRequest}

    export const useHireJobsWorkingInterviewSeriesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesCreate>>, TError,HireJobsWorkingInterviewSeriesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesCreate>>,
        TError,
        HireJobsWorkingInterviewSeriesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsWorkingInterviewSeriesCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsWorkingInterviewSeriesPreviewCreateUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/working-interview-series/preview/`
}

/**
 * How many working-interview shifts a series would post, and when, so the business sees exactly what it gets before it posts. Nothing is created. 404 when the job is not at a location the caller manages or the working-interview feature is off for the location.
 */
export const hireJobsWorkingInterviewSeriesPreviewCreate = async (jobPostingId: string,
    workingInterviewSeriesPreviewRequestRequest: WorkingInterviewSeriesPreviewRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewSeriesPreview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewSeriesPreview>(getHireJobsWorkingInterviewSeriesPreviewCreateUrl(jobPostingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingInterviewSeriesPreviewRequestRequest)
  }
);}





export const getHireJobsWorkingInterviewSeriesPreviewCreateMutationKey = () => ['hireJobsWorkingInterviewSeriesPreviewCreate'] as const;

export const getHireJobsWorkingInterviewSeriesPreviewCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesPreviewCreate>>, TError,HireJobsWorkingInterviewSeriesPreviewCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesPreviewCreate>>, TError,HireJobsWorkingInterviewSeriesPreviewCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsWorkingInterviewSeriesPreviewCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesPreviewCreate>>, HireJobsWorkingInterviewSeriesPreviewCreateMutationVariables> = (props) => {
          const {jobPostingId,data} = props ?? {};

          return  hireJobsWorkingInterviewSeriesPreviewCreate(jobPostingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsWorkingInterviewSeriesPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesPreviewCreate>>>
    export type HireJobsWorkingInterviewSeriesPreviewCreateMutationBody = WorkingInterviewSeriesPreviewRequestRequest
    export type HireJobsWorkingInterviewSeriesPreviewCreateMutationError = void
    export type HireJobsWorkingInterviewSeriesPreviewCreateMutationVariables = {jobPostingId: string;data: WorkingInterviewSeriesPreviewRequestRequest}

    export const useHireJobsWorkingInterviewSeriesPreviewCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesPreviewCreate>>, TError,HireJobsWorkingInterviewSeriesPreviewCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsWorkingInterviewSeriesPreviewCreate>>,
        TError,
        HireJobsWorkingInterviewSeriesPreviewCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsWorkingInterviewSeriesPreviewCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsWorkingInterviewsRetrieveUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/working-interviews/`
}

/**
 * The job page's working-interviews panel: the job's shifts by date, each seat with its status (finding, confirmed, cancelled_refilling, filled_as_regular, done), the booked Pro and why they were picked, plus the job's latest activity. Each working-interview shift also lists every Pro invited to it (`invites`, first-invited first, one row per Pro) with the reason they were picked and a status (invited, booked, declined, expired, cancelled); `invites` is null on a shift that went back to regular. 404 when the job is not at a location the caller manages or the working-interview feature is off for the location.
 */
export const hireJobsWorkingInterviewsRetrieve = async (jobPostingId: string, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewPanel> => {

  return customFetch<WorkingInterviewPanel>(getHireJobsWorkingInterviewsRetrieveUrl(jobPostingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsWorkingInterviewsRetrieveQueryKey = (jobPostingId: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/working-interviews/`
    ] as const;
    }


export const getHireJobsWorkingInterviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError = void>(jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsWorkingInterviewsRetrieveQueryKey(jobPostingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>> = ({ signal }) => hireJobsWorkingInterviewsRetrieve(jobPostingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsWorkingInterviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>>
export type HireJobsWorkingInterviewsRetrieveQueryError = void


export function useHireJobsWorkingInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError = void>(
 jobPostingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsWorkingInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsWorkingInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsWorkingInterviewsRetrieve<TData = Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError = void>(
 jobPostingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsWorkingInterviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsWorkingInterviewsRetrieveQueryOptions(jobPostingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireLocationsConvertibleShiftsRetrieveUrl = (locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/locations/${locationId}/convertible-shifts/?${stringifiedParams}` : `/api/hire/locations/${locationId}/convertible-shifts/`
}

/**
 * The same list as the job-keyed route, for a job that is not posted yet: upcoming shifts at the location in the position with a seat nobody is confirmed on, soonest first. 404 when the caller does not manage the location or the working-interview feature is off for it.
 */
export const hireLocationsConvertibleShiftsRetrieve = async (locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<ConvertibleShiftsResponse> => {

  return customFetch<ConvertibleShiftsResponse>(getHireLocationsConvertibleShiftsRetrieveUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireLocationsConvertibleShiftsRetrieveQueryKey = (locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams,) => {
    return [
    `/api/hire/locations/${locationId}/convertible-shifts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireLocationsConvertibleShiftsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError = void>(locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireLocationsConvertibleShiftsRetrieveQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>> = ({ signal }) => hireLocationsConvertibleShiftsRetrieve(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireLocationsConvertibleShiftsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>>
export type HireLocationsConvertibleShiftsRetrieveQueryError = void


export function useHireLocationsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError = void>(
 locationId: number,
    params: undefined |  HireLocationsConvertibleShiftsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireLocationsConvertibleShiftsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsConvertibleShiftsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsConvertibleShiftsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireLocationsConvertibleShiftsRetrieveQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireLocationsDirectHireCreateUrl = (locationId: number,) => {




  return `/api/hire/locations/${locationId}/direct-hire/`
}

/**
 * Hire a Pro without posting a job: creates a private job only the business and that Pro can see, and sends the job offer on it. A retry for a Pro and position that already has a sent direct-hire offer at the location returns that offer with 200. 403 jobs_subscription_required when the location has no Jobs trial or plan; 404 when the caller does not manage the location.
 */
export const hireLocationsDirectHireCreate = async (locationId: number,
    directHireCreateRequest: DirectHireCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferJobOffer>(getHireLocationsDirectHireCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(directHireCreateRequest)
  }
);}





export const getHireLocationsDirectHireCreateMutationKey = () => ['hireLocationsDirectHireCreate'] as const;

export const getHireLocationsDirectHireCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireLocationsDirectHireCreate>>, TError,HireLocationsDirectHireCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireLocationsDirectHireCreate>>, TError,HireLocationsDirectHireCreateMutationVariables, TContext> => {

const mutationKey = getHireLocationsDirectHireCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireLocationsDirectHireCreate>>, HireLocationsDirectHireCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  hireLocationsDirectHireCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireLocationsDirectHireCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireLocationsDirectHireCreate>>>
    export type HireLocationsDirectHireCreateMutationBody = DirectHireCreateRequest
    export type HireLocationsDirectHireCreateMutationError = void
    export type HireLocationsDirectHireCreateMutationVariables = {locationId: number;data: DirectHireCreateRequest}

    export const useHireLocationsDirectHireCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireLocationsDirectHireCreate>>, TError,HireLocationsDirectHireCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireLocationsDirectHireCreate>>,
        TError,
        HireLocationsDirectHireCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireLocationsDirectHireCreateMutationOptions(options), queryClient);
    }
    export const getHireLocationsDirectHirePreviewRetrieveUrl = (locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/locations/${locationId}/direct-hire-preview/?${stringifiedParams}` : `/api/hire/locations/${locationId}/direct-hire-preview/`
}

/**
 * What the direct-hire form shows before submit: the default wage a new job at this location and position gets (null when none resolves) and the count of the Pro's future booked shifts across the organization's locations that a full-time accept would cancel. 404 when the caller does not manage the location or the Pro or position does not exist.
 */
export const hireLocationsDirectHirePreviewRetrieve = async (locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<DirectHirePreviewResponse> => {

  return customFetch<DirectHirePreviewResponse>(getHireLocationsDirectHirePreviewRetrieveUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireLocationsDirectHirePreviewRetrieveQueryKey = (locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams,) => {
    return [
    `/api/hire/locations/${locationId}/direct-hire-preview/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireLocationsDirectHirePreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError = void>(locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireLocationsDirectHirePreviewRetrieveQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>> = ({ signal }) => hireLocationsDirectHirePreviewRetrieve(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireLocationsDirectHirePreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>>
export type HireLocationsDirectHirePreviewRetrieveQueryError = void


export function useHireLocationsDirectHirePreviewRetrieve<TData = Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError = void>(
 locationId: number,
    params: undefined |  HireLocationsDirectHirePreviewRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsDirectHirePreviewRetrieve<TData = Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsDirectHirePreviewRetrieve<TData = Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireLocationsDirectHirePreviewRetrieve<TData = Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsDirectHirePreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsDirectHirePreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireLocationsDirectHirePreviewRetrieveQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireLocationsOfferableJobsRetrieveUrl = (locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/locations/${locationId}/offerable-jobs/?${stringifiedParams}` : `/api/hire/locations/${locationId}/offerable-jobs/`
}

/**
 * The location's open jobs this Pro could be offered: jobs whose position the Pro qualifies for as "worked with you" (a Pro the location blocked qualifies for none), leaving out jobs where they already have an offer or were dismissed. When the location has no Jobs access, jobs the Pro applied to are also left out: their applications are hidden. Newest job first. With position_id, direct_hire_available says whether the Pro can be hired directly in that position: they qualify as "worked with you" for it, the location has no open job in it, and the Pro has no rejected or offered candidate row on any job in it there. 404 when the caller does not manage the location.
 */
export const hireLocationsOfferableJobsRetrieve = async (locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<OfferableJobsResponse> => {

  return customFetch<OfferableJobsResponse>(getHireLocationsOfferableJobsRetrieveUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireLocationsOfferableJobsRetrieveQueryKey = (locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams,) => {
    return [
    `/api/hire/locations/${locationId}/offerable-jobs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireLocationsOfferableJobsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError = void>(locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireLocationsOfferableJobsRetrieveQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>> = ({ signal }) => hireLocationsOfferableJobsRetrieve(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireLocationsOfferableJobsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>>
export type HireLocationsOfferableJobsRetrieveQueryError = void


export function useHireLocationsOfferableJobsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError = void>(
 locationId: number,
    params: undefined |  HireLocationsOfferableJobsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsOfferableJobsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsOfferableJobsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireLocationsOfferableJobsRetrieve<TData = Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsOfferableJobsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsOfferableJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireLocationsOfferableJobsRetrieveQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireLocationsReadyToHireRetrieveUrl = (locationId: number,) => {




  return `/api/hire/locations/${locationId}/ready-to-hire/`
}

/**
 * Applicants at the location's open jobs who "worked with you" and have no offer yet and were not dismissed, most recent application first. Empty when the location has no Jobs access: applicants are hidden. 404 when the caller does not manage the location.
 */
export const hireLocationsReadyToHireRetrieve = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<ReadyToHireResponse> => {

  return customFetch<ReadyToHireResponse>(getHireLocationsReadyToHireRetrieveUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireLocationsReadyToHireRetrieveQueryKey = (locationId: number,) => {
    return [
    `/api/hire/locations/${locationId}/ready-to-hire/`
    ] as const;
    }


export const getHireLocationsReadyToHireRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireLocationsReadyToHireRetrieveQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>> = ({ signal }) => hireLocationsReadyToHireRetrieve(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireLocationsReadyToHireRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>>
export type HireLocationsReadyToHireRetrieveQueryError = void


export function useHireLocationsReadyToHireRetrieve<TData = Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsReadyToHireRetrieve<TData = Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsReadyToHireRetrieve<TData = Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireLocationsReadyToHireRetrieve<TData = Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsReadyToHireRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireLocationsReadyToHireRetrieveQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireLocationsWeeklyPatternRetrieveUrl = (locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/locations/${locationId}/weekly-pattern/?${stringifiedParams}` : `/api/hire/locations/${locationId}/weekly-pattern/`
}

/**
 * The dominant weekly shift pattern for a role at the location over the last 8 weeks: the most common start time, end time and headcount, and the weekdays it recurs on. Cancelled shifts and Hire interview gigs are ignored, and a spot split off into a tryout counts toward its shift. `pattern` is null when there is no history. 404 when the caller does not manage the location.
 */
export const hireLocationsWeeklyPatternRetrieve = async (locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<WeeklyPatternResponse> => {

  return customFetch<WeeklyPatternResponse>(getHireLocationsWeeklyPatternRetrieveUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireLocationsWeeklyPatternRetrieveQueryKey = (locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams,) => {
    return [
    `/api/hire/locations/${locationId}/weekly-pattern/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireLocationsWeeklyPatternRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError = void>(locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireLocationsWeeklyPatternRetrieveQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>> = ({ signal }) => hireLocationsWeeklyPatternRetrieve(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireLocationsWeeklyPatternRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>>
export type HireLocationsWeeklyPatternRetrieveQueryError = void


export function useHireLocationsWeeklyPatternRetrieve<TData = Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError = void>(
 locationId: number,
    params: undefined |  HireLocationsWeeklyPatternRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsWeeklyPatternRetrieve<TData = Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireLocationsWeeklyPatternRetrieve<TData = Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireLocationsWeeklyPatternRetrieve<TData = Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError = void>(
 locationId: number,
    params?: HireLocationsWeeklyPatternRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireLocationsWeeklyPatternRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireLocationsWeeklyPatternRetrieveQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireLocationsWorkingInterviewSeriesPreviewCreateUrl = (locationId: number,) => {




  return `/api/hire/locations/${locationId}/working-interview-series/preview/`
}

/**
 * The same preview as the job-keyed route, for a job that is not posted yet: how many working-interview shifts a series would post, and when. Nothing is created. 404 when the caller does not manage the location or the working-interview feature is off for it.
 */
export const hireLocationsWorkingInterviewSeriesPreviewCreate = async (locationId: number,
    workingInterviewSeriesPreviewRequestRequest: WorkingInterviewSeriesPreviewRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewSeriesPreview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewSeriesPreview>(getHireLocationsWorkingInterviewSeriesPreviewCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingInterviewSeriesPreviewRequestRequest)
  }
);}





export const getHireLocationsWorkingInterviewSeriesPreviewCreateMutationKey = () => ['hireLocationsWorkingInterviewSeriesPreviewCreate'] as const;

export const getHireLocationsWorkingInterviewSeriesPreviewCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireLocationsWorkingInterviewSeriesPreviewCreate>>, TError,HireLocationsWorkingInterviewSeriesPreviewCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireLocationsWorkingInterviewSeriesPreviewCreate>>, TError,HireLocationsWorkingInterviewSeriesPreviewCreateMutationVariables, TContext> => {

const mutationKey = getHireLocationsWorkingInterviewSeriesPreviewCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireLocationsWorkingInterviewSeriesPreviewCreate>>, HireLocationsWorkingInterviewSeriesPreviewCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  hireLocationsWorkingInterviewSeriesPreviewCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireLocationsWorkingInterviewSeriesPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireLocationsWorkingInterviewSeriesPreviewCreate>>>
    export type HireLocationsWorkingInterviewSeriesPreviewCreateMutationBody = WorkingInterviewSeriesPreviewRequestRequest
    export type HireLocationsWorkingInterviewSeriesPreviewCreateMutationError = void
    export type HireLocationsWorkingInterviewSeriesPreviewCreateMutationVariables = {locationId: number;data: WorkingInterviewSeriesPreviewRequestRequest}

    export const useHireLocationsWorkingInterviewSeriesPreviewCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireLocationsWorkingInterviewSeriesPreviewCreate>>, TError,HireLocationsWorkingInterviewSeriesPreviewCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireLocationsWorkingInterviewSeriesPreviewCreate>>,
        TError,
        HireLocationsWorkingInterviewSeriesPreviewCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireLocationsWorkingInterviewSeriesPreviewCreateMutationOptions(options), queryClient);
    }
    export const getJobCandidatesListUrl = (params?: JobCandidatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-candidates/?${stringifiedParams}` : `/api/job-candidates/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Job applicants API (access control via queryset).
 *
 * Mounted twice: nested under a job as ``/hire/jobs/{job_id}/applicants/`` (canonical) and at the
 * deprecated flat ``/job-candidates/`` where the job is a query param instead. On the nested route
 * the ``job_posting_id`` path segment scopes the list; the query param is ignored there.
 *
 * - GET /hire/jobs/{job_id}/applicants/ - list applicants for a job
 * - GET /job-candidates/?job_posting_id={uuid} - deprecated flat equivalent
 * - GET .../{id}/ - get applicant detail
 * - GET .../{id}/timeline/ - get applicant's interviews and job offers
 * - GET .../{id}/ai-screening/transcript/ - fetch AI screening transcript on demand
 * - PATCH .../{id}/ - update applicant (e.g., {"stage": "REJECTED"})
 * - POST .../{id}/invite/resend/ - resend an SMS invite to apply (once)
 *
 * Supports ordering:
 * - ordering: Sort by -match_score (default), -created_ts, -avg_rating, or -completion_percentage
 *
 * Boolean filters (is_preferred and in_network need a job — the path segment on the nested route,
 * the job_posting_id query param on the flat one):
 * - is_preferred: Filter by favorited pros at the location
 * - in_network: Filter by pros in the organization's network
 * - background_check: Filter by pros with cleared background checks
 * - food_handler: Filter by pros with active Food Handler certification
 * - alcohol_safety: Filter by pros with active Alcohol Safety certification
 * - qwick_certified: Filter by Qwick-certified pros
 * - has_badges: Filter by pros with active tiered badges (GOLD/SILVER/BRONZE)
 * - employment_types: Filter by pro's supported employment type(s) (W2/F1099, comma-separated)
 * - worked_with_you: true keeps applicants who count as "worked with you"; false leaves them out
 *
 * All boolean filters use AND logic when combined.
 * @deprecated
 */
export const jobCandidatesList = async (params?: JobCandidatesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobApplicantResponseList> => {

  return customFetch<PaginatedJobApplicantResponseList>(getJobCandidatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesListInfiniteQueryKey = (params?: JobCandidatesListParams,) => {
    return [
    'infinite', `/api/job-candidates/`, ...(params ? [params] : [])
    ] as const;
    }

export const getJobCandidatesListQueryKey = (params?: JobCandidatesListParams,) => {
    return [
    `/api/job-candidates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobCandidatesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof jobCandidatesList>>, JobCandidatesListParams['page']>, TError = void>(params?: JobCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData, QueryKey, JobCandidatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesList>>, QueryKey, JobCandidatesListParams['page']> = ({ signal, pageParam }) => jobCandidatesList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData, QueryKey, JobCandidatesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesList>>>
export type JobCandidatesListInfiniteQueryError = void


export function useJobCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCandidatesList>>, JobCandidatesListParams['page']>, TError = void>(
 params: undefined |  JobCandidatesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData, QueryKey, JobCandidatesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCandidatesList>>, JobCandidatesListParams['page']>, TError = void>(
 params?: JobCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData, QueryKey, JobCandidatesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCandidatesList>>, JobCandidatesListParams['page']>, TError = void>(
 params?: JobCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData, QueryKey, JobCandidatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobCandidatesList>>, JobCandidatesListParams['page']>, TError = void>(
 params?: JobCandidatesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData, QueryKey, JobCandidatesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesListQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesList>>, TError = void>(params?: JobCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesList>>> = ({ signal }) => jobCandidatesList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesListQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesList>>>
export type JobCandidatesListQueryError = void


export function useJobCandidatesList<TData = Awaited<ReturnType<typeof jobCandidatesList>>, TError = void>(
 params: undefined |  JobCandidatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesList<TData = Awaited<ReturnType<typeof jobCandidatesList>>, TError = void>(
 params?: JobCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesList>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesList<TData = Awaited<ReturnType<typeof jobCandidatesList>>, TError = void>(
 params?: JobCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesList<TData = Awaited<ReturnType<typeof jobCandidatesList>>, TError = void>(
 params?: JobCandidatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesRetrieveUrl = (id: string,) => {




  return `/api/job-candidates/${id}/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Job applicants API (access control via queryset).
 *
 * Mounted twice: nested under a job as ``/hire/jobs/{job_id}/applicants/`` (canonical) and at the
 * deprecated flat ``/job-candidates/`` where the job is a query param instead. On the nested route
 * the ``job_posting_id`` path segment scopes the list; the query param is ignored there.
 *
 * - GET /hire/jobs/{job_id}/applicants/ - list applicants for a job
 * - GET /job-candidates/?job_posting_id={uuid} - deprecated flat equivalent
 * - GET .../{id}/ - get applicant detail
 * - GET .../{id}/timeline/ - get applicant's interviews and job offers
 * - GET .../{id}/ai-screening/transcript/ - fetch AI screening transcript on demand
 * - PATCH .../{id}/ - update applicant (e.g., {"stage": "REJECTED"})
 * - POST .../{id}/invite/resend/ - resend an SMS invite to apply (once)
 *
 * Supports ordering:
 * - ordering: Sort by -match_score (default), -created_ts, -avg_rating, or -completion_percentage
 *
 * Boolean filters (is_preferred and in_network need a job — the path segment on the nested route,
 * the job_posting_id query param on the flat one):
 * - is_preferred: Filter by favorited pros at the location
 * - in_network: Filter by pros in the organization's network
 * - background_check: Filter by pros with cleared background checks
 * - food_handler: Filter by pros with active Food Handler certification
 * - alcohol_safety: Filter by pros with active Alcohol Safety certification
 * - qwick_certified: Filter by Qwick-certified pros
 * - has_badges: Filter by pros with active tiered badges (GOLD/SILVER/BRONZE)
 * - employment_types: Filter by pro's supported employment type(s) (W2/F1099, comma-separated)
 * - worked_with_you: true keeps applicants who count as "worked with you"; false leaves them out
 *
 * All boolean filters use AND logic when combined.
 * @deprecated
 */
export const jobCandidatesRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantDetailResponse> => {

  return customFetch<JobApplicantDetailResponse>(getJobCandidatesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesRetrieveQueryKey = (id: string,) => {
    return [
    `/api/job-candidates/${id}/`
    ] as const;
    }


export const getJobCandidatesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesRetrieve>>> = ({ signal }) => jobCandidatesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesRetrieve>>>
export type JobCandidatesRetrieveQueryError = void


export function useJobCandidatesRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesPartialUpdateUrl = (id: string,) => {




  return `/api/job-candidates/${id}/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Update candidate stage (e.g., "REJECTED" to dismiss a candidate).
 * @deprecated
 */
export const jobCandidatesPartialUpdate = async (id: string,
    patchedJobApplicantRequest?: PatchedJobApplicantRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobApplicantResponse>(getJobCandidatesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobApplicantRequest)
  }
);}





export const getJobCandidatesPartialUpdateMutationKey = () => ['jobCandidatesPartialUpdate'] as const;

export const getJobCandidatesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesPartialUpdate>>, TError,JobCandidatesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesPartialUpdate>>, TError,JobCandidatesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getJobCandidatesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCandidatesPartialUpdate>>, JobCandidatesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  jobCandidatesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCandidatesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesPartialUpdate>>>
    export type JobCandidatesPartialUpdateMutationBody = PatchedJobApplicantRequest | undefined
    export type JobCandidatesPartialUpdateMutationError = void
    export type JobCandidatesPartialUpdateMutationVariables = {id: string;data?: PatchedJobApplicantRequest}

    /**
 * @deprecated
 */
export const useJobCandidatesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesPartialUpdate>>, TError,JobCandidatesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCandidatesPartialUpdate>>,
        TError,
        JobCandidatesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCandidatesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getJobCandidatesAiScreeningRetrieveUrl = (id: string,) => {




  return `/api/job-candidates/${id}/ai-screening/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Return the most recent AI screening for the candidate inside a ``{"screening": ...}`` envelope. ``screening`` is null if none has been sent yet. When the screening status is ``COMPLETED`` and the webhook has cached the structured result, ``summary`` / ``key_takeaway`` / ``notable_quote`` / ``concerns`` are populated as flat fields on the screening object (all four stay null pre-completion or when the post-completion vendor fetch failed). A pro-initiated screening only surfaces once ``COMPLETED`` — an abandoned in-app attempt has no retry and would otherwise show as a stale pending interview to the hiring team. 404 only if the candidate is not managed by the requesting user.
 * @deprecated
 */
export const jobCandidatesAiScreeningRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantAIScreeningEnvelope> => {

  return customFetch<JobApplicantAIScreeningEnvelope>(getJobCandidatesAiScreeningRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesAiScreeningRetrieveQueryKey = (id: string,) => {
    return [
    `/api/job-candidates/${id}/ai-screening/`
    ] as const;
    }


export const getJobCandidatesAiScreeningRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesAiScreeningRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>> = ({ signal }) => jobCandidatesAiScreeningRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesAiScreeningRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>>
export type JobCandidatesAiScreeningRetrieveQueryError = void


export function useJobCandidatesAiScreeningRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesAiScreeningRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesAiScreeningRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesAiScreeningRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesAiScreeningRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesAiScreeningCreateUrl = (id: string,) => {




  return `/api/job-candidates/${id}/ai-screening/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Send an AI screening invite to the candidate. Returns 201 when a new invite is minted, or 200 with the existing screening when one is already outstanding (non-terminal) for this candidate.
 * @deprecated
 */
export const jobCandidatesAiScreeningCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantAIScreening> => {

  return customFetch<JobApplicantAIScreening>(getJobCandidatesAiScreeningCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJobCandidatesAiScreeningCreateMutationKey = () => ['jobCandidatesAiScreeningCreate'] as const;

export const getJobCandidatesAiScreeningCreateMutationOptions = <TError = AIScreeningValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningCreate>>, TError,JobCandidatesAiScreeningCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningCreate>>, TError,JobCandidatesAiScreeningCreateMutationVariables, TContext> => {

const mutationKey = getJobCandidatesAiScreeningCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCandidatesAiScreeningCreate>>, JobCandidatesAiScreeningCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  jobCandidatesAiScreeningCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCandidatesAiScreeningCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesAiScreeningCreate>>>

    export type JobCandidatesAiScreeningCreateMutationError = AIScreeningValidationError | void
    export type JobCandidatesAiScreeningCreateMutationVariables = {id: string}

    /**
 * @deprecated
 */
export const useJobCandidatesAiScreeningCreate = <TError = AIScreeningValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningCreate>>, TError,JobCandidatesAiScreeningCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCandidatesAiScreeningCreate>>,
        TError,
        JobCandidatesAiScreeningCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCandidatesAiScreeningCreateMutationOptions(options), queryClient);
    }
    export const getJobCandidatesAiScreeningTranscriptRetrieveUrl = (id: string,) => {




  return `/api/job-candidates/${id}/ai-screening/transcript/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Fetch the raw conversation transcript for the candidate's most recent AI screening. Live fetch from the vendor — no local cache — to keep transcript data off our DB while still letting the FE render the "Read the raw conversation" view on demand.
 *
 * 404 if the candidate is not managed by the requesting user, no screening exists, or the latest screening is not in ``COMPLETED`` status. 502 if the vendor is unreachable or returns an error.
 * @deprecated
 */
export const jobCandidatesAiScreeningTranscriptRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobApplicantAIScreeningTranscriptEnvelope> => {

  return customFetch<JobApplicantAIScreeningTranscriptEnvelope>(getJobCandidatesAiScreeningTranscriptRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesAiScreeningTranscriptRetrieveQueryKey = (id: string,) => {
    return [
    `/api/job-candidates/${id}/ai-screening/transcript/`
    ] as const;
    }


export const getJobCandidatesAiScreeningTranscriptRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesAiScreeningTranscriptRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>> = ({ signal }) => jobCandidatesAiScreeningTranscriptRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesAiScreeningTranscriptRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>>
export type JobCandidatesAiScreeningTranscriptRetrieveQueryError = void | AIScreeningTranscriptVendorError


export function useJobCandidatesAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesAiScreeningTranscriptRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError = void | AIScreeningTranscriptVendorError>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesAiScreeningTranscriptRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesAiScreeningTranscriptRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesInviteResendCreateUrl = (id: string,) => {




  return `/api/job-candidates/${id}/invite/resend/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Text the invite to apply again and restart its 7-day expiry. Allowed once per invite; 400 once resent, after the applicant is removed or has applied, or when there is no invite.
 * @deprecated
 */
export const jobCandidatesInviteResendCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobCandidateInvite> => {

  return customFetch<JobCandidateInvite>(getJobCandidatesInviteResendCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJobCandidatesInviteResendCreateMutationKey = () => ['jobCandidatesInviteResendCreate'] as const;

export const getJobCandidatesInviteResendCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesInviteResendCreate>>, TError,JobCandidatesInviteResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesInviteResendCreate>>, TError,JobCandidatesInviteResendCreateMutationVariables, TContext> => {

const mutationKey = getJobCandidatesInviteResendCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCandidatesInviteResendCreate>>, JobCandidatesInviteResendCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  jobCandidatesInviteResendCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCandidatesInviteResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesInviteResendCreate>>>

    export type JobCandidatesInviteResendCreateMutationError = void
    export type JobCandidatesInviteResendCreateMutationVariables = {id: string}

    /**
 * @deprecated
 */
export const useJobCandidatesInviteResendCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesInviteResendCreate>>, TError,JobCandidatesInviteResendCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCandidatesInviteResendCreate>>,
        TError,
        JobCandidatesInviteResendCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCandidatesInviteResendCreateMutationOptions(options), queryClient);
    }
    export const getJobCandidatesTimelineRetrieveUrl = (id: string,) => {




  return `/api/job-candidates/${id}/timeline/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Job applicants API (access control via queryset).
 *
 * Mounted twice: nested under a job as ``/hire/jobs/{job_id}/applicants/`` (canonical) and at the
 * deprecated flat ``/job-candidates/`` where the job is a query param instead. On the nested route
 * the ``job_posting_id`` path segment scopes the list; the query param is ignored there.
 *
 * - GET /hire/jobs/{job_id}/applicants/ - list applicants for a job
 * - GET /job-candidates/?job_posting_id={uuid} - deprecated flat equivalent
 * - GET .../{id}/ - get applicant detail
 * - GET .../{id}/timeline/ - get applicant's interviews and job offers
 * - GET .../{id}/ai-screening/transcript/ - fetch AI screening transcript on demand
 * - PATCH .../{id}/ - update applicant (e.g., {"stage": "REJECTED"})
 * - POST .../{id}/invite/resend/ - resend an SMS invite to apply (once)
 *
 * Supports ordering:
 * - ordering: Sort by -match_score (default), -created_ts, -avg_rating, or -completion_percentage
 *
 * Boolean filters (is_preferred and in_network need a job — the path segment on the nested route,
 * the job_posting_id query param on the flat one):
 * - is_preferred: Filter by favorited pros at the location
 * - in_network: Filter by pros in the organization's network
 * - background_check: Filter by pros with cleared background checks
 * - food_handler: Filter by pros with active Food Handler certification
 * - alcohol_safety: Filter by pros with active Alcohol Safety certification
 * - qwick_certified: Filter by Qwick-certified pros
 * - has_badges: Filter by pros with active tiered badges (GOLD/SILVER/BRONZE)
 * - employment_types: Filter by pro's supported employment type(s) (W2/F1099, comma-separated)
 * - worked_with_you: true keeps applicants who count as "worked with you"; false leaves them out
 *
 * All boolean filters use AND logic when combined.
 * @deprecated
 */
export const jobCandidatesTimelineRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<CandidateTimeline> => {

  return customFetch<CandidateTimeline>(getJobCandidatesTimelineRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesTimelineRetrieveQueryKey = (id: string,) => {
    return [
    `/api/job-candidates/${id}/timeline/`
    ] as const;
    }


export const getJobCandidatesTimelineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesTimelineRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>> = ({ signal }) => jobCandidatesTimelineRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesTimelineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>>
export type JobCandidatesTimelineRetrieveQueryError = void


export function useJobCandidatesTimelineRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesTimelineRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesTimelineRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesTimelineRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTimelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesTimelineRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesTryoutsCreateUrl = (id: string,) => {




  return `/api/job-candidates/${id}/tryouts/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Offer a working-interview tryout on one of the manager's shifts (see tryout-shifts): a spot on a multi-spot shift splits off into a private one-Pro shift, a one-spot shift is replaced by it. One of the job's own working-interview seats is offered to the candidate directly, with no new shift. All-or-nothing: on a 400 the original shift is untouched. 404 when the tryout feature is off for the location.
 * @deprecated
 */
export const jobCandidatesTryoutsCreate = async (id: string,
    tryoutOfferRequest: TryoutOfferRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewResult>(getJobCandidatesTryoutsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tryoutOfferRequest)
  }
);}





export const getJobCandidatesTryoutsCreateMutationKey = () => ['jobCandidatesTryoutsCreate'] as const;

export const getJobCandidatesTryoutsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesTryoutsCreate>>, TError,JobCandidatesTryoutsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesTryoutsCreate>>, TError,JobCandidatesTryoutsCreateMutationVariables, TContext> => {

const mutationKey = getJobCandidatesTryoutsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCandidatesTryoutsCreate>>, JobCandidatesTryoutsCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  jobCandidatesTryoutsCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCandidatesTryoutsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesTryoutsCreate>>>
    export type JobCandidatesTryoutsCreateMutationBody = TryoutOfferRequest
    export type JobCandidatesTryoutsCreateMutationError = void
    export type JobCandidatesTryoutsCreateMutationVariables = {id: string;data: TryoutOfferRequest}

    /**
 * @deprecated
 */
export const useJobCandidatesTryoutsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesTryoutsCreate>>, TError,JobCandidatesTryoutsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCandidatesTryoutsCreate>>,
        TError,
        JobCandidatesTryoutsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCandidatesTryoutsCreateMutationOptions(options), queryClient);
    }
    export const getJobCandidatesWorkingInterviewsCreateUrl = (id: string,) => {




  return `/api/job-candidates/${id}/working-interviews/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Create working interview(s) for a job candidate by offering gig(s) as paid trial shifts.
 * @deprecated
 */
export const jobCandidatesWorkingInterviewsCreate = async (id: string,
    workingInterviewCreateRequest: WorkingInterviewCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<WorkingInterviewCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WorkingInterviewCreateResponse>(getJobCandidatesWorkingInterviewsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workingInterviewCreateRequest)
  }
);}





export const getJobCandidatesWorkingInterviewsCreateMutationKey = () => ['jobCandidatesWorkingInterviewsCreate'] as const;

export const getJobCandidatesWorkingInterviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesWorkingInterviewsCreate>>, TError,JobCandidatesWorkingInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesWorkingInterviewsCreate>>, TError,JobCandidatesWorkingInterviewsCreateMutationVariables, TContext> => {

const mutationKey = getJobCandidatesWorkingInterviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCandidatesWorkingInterviewsCreate>>, JobCandidatesWorkingInterviewsCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  jobCandidatesWorkingInterviewsCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCandidatesWorkingInterviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesWorkingInterviewsCreate>>>
    export type JobCandidatesWorkingInterviewsCreateMutationBody = WorkingInterviewCreateRequest
    export type JobCandidatesWorkingInterviewsCreateMutationError = void
    export type JobCandidatesWorkingInterviewsCreateMutationVariables = {id: string;data: WorkingInterviewCreateRequest}

    /**
 * @deprecated
 */
export const useJobCandidatesWorkingInterviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCandidatesWorkingInterviewsCreate>>, TError,JobCandidatesWorkingInterviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCandidatesWorkingInterviewsCreate>>,
        TError,
        JobCandidatesWorkingInterviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobCandidatesWorkingInterviewsCreateMutationOptions(options), queryClient);
    }
    export const getJobCandidatesFunnelCountsRetrieveUrl = (params?: JobCandidatesFunnelCountsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-candidates/funnel-counts/?${stringifiedParams}` : `/api/job-candidates/funnel-counts/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * Per-tab candidate counts for the funnel stages, honoring the same filters as the list endpoint (except funnel_stage). Lets the web app render the funnel tabs without splitting the paginated list client-side.
 * @deprecated
 */
export const jobCandidatesFunnelCountsRetrieve = async (params?: JobCandidatesFunnelCountsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<FunnelCounts> => {

  return customFetch<FunnelCounts>(getJobCandidatesFunnelCountsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesFunnelCountsRetrieveQueryKey = (params?: JobCandidatesFunnelCountsRetrieveParams,) => {
    return [
    `/api/job-candidates/funnel-counts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobCandidatesFunnelCountsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError = void>(params?: JobCandidatesFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesFunnelCountsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>> = ({ signal }) => jobCandidatesFunnelCountsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesFunnelCountsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>>
export type JobCandidatesFunnelCountsRetrieveQueryError = void


export function useJobCandidatesFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError = void>(
 params: undefined |  JobCandidatesFunnelCountsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError = void>(
 params?: JobCandidatesFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError = void>(
 params?: JobCandidatesFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesFunnelCountsRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError = void>(
 params?: JobCandidatesFunnelCountsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesFunnelCountsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesFunnelCountsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobCandidatesTeaserRetrieveUrl = (params?: JobCandidatesTeaserRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-candidates/teaser/?${stringifiedParams}` : `/api/job-candidates/teaser/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_id}/applicants/ instead. Behaviour is identical.
 *
 * What a location without Jobs access may see about a job's applicants, or about the whole location's when no job is given (the location comes from the location header): counts, the top 3 applied or passed-screening applicants (first name and last initial, headshot, experience, worked-with-you, AI summary, the job-candidate id and the job), and one row per other applicant with stage, applied time and distance band, never who they are. The top 3 can be opened in full through the applicant detail reads.
 * @deprecated
 */
export const jobCandidatesTeaserRetrieve = async (params?: JobCandidatesTeaserRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<ApplicantTeaser> => {

  return customFetch<ApplicantTeaser>(getJobCandidatesTeaserRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCandidatesTeaserRetrieveQueryKey = (params?: JobCandidatesTeaserRetrieveParams,) => {
    return [
    `/api/job-candidates/teaser/`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobCandidatesTeaserRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError = void>(params?: JobCandidatesTeaserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCandidatesTeaserRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>> = ({ signal }) => jobCandidatesTeaserRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCandidatesTeaserRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>>
export type JobCandidatesTeaserRetrieveQueryError = void


export function useJobCandidatesTeaserRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError = void>(
 params: undefined |  JobCandidatesTeaserRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesTeaserRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError = void>(
 params?: JobCandidatesTeaserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCandidatesTeaserRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError = void>(
 params?: JobCandidatesTeaserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobCandidatesTeaserRetrieve<TData = Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError = void>(
 params?: JobCandidatesTeaserRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCandidatesTeaserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCandidatesTeaserRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






